import $ from "jquery";

export default class EventCheckboxManager {
  constructor(selector) {
      this.checkboxes = $(selector);
      this.initEvents();
  }

  initEvents() {
      this.checkboxes.on('change', (event) => this.handleCheckboxChange(event));
  }

  handleCheckboxChange(event) {
      const changedCheckbox = $(event.target);
      const eventID = changedCheckbox.data('eventid');
      const relatedCheckboxes = $(`input[type="checkbox"][data-eventid='${eventID}']`);

      if (changedCheckbox.is(':checked')) {
          relatedCheckboxes.each((index, item) => {
              if (item !== event.target) {
                  $(item).prop('checked', false).prop('disabled', true);
              }
          });
      } else {
          relatedCheckboxes.each((index, item) => {
              $(item).prop('disabled', false);
          });
      }
  }

  static mount(selector) {
      const instance = new EventCheckboxManager(selector);
      return instance; // In diesem Kontext könnte es optional sein, die Instanz zurückzugeben.
  }
}
